import { ServicesApiService } from 'src/app/core/services/api/services-api.service';
import { StatusEnum } from 'src/app/shared/models/cases/caseSearchParams';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CourtsApiService } from 'src/app/core/services/api/courts-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PrintService } from 'src/app/core/services/print.service';
import { CreateNewClaimComponent } from 'src/app/shared/create-new-claim/create-new-claim.component';
import { CaseLawyerHistoryComponent } from '../case-lawyer-history/case-lawyer-history.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { CreateEditFileClientComponent } from '../create-edit-file-client/create-edit-file-client.component';
import { CreateEditCaseOpponentComponent } from '../create-edit-opponent/create-edit-opponent.component';
import { Case, CaseBase, CaseWrite } from '../models/cases/case';
import { CaseClient } from '../models/cases/caseClient';
import { CaseLawyer } from '../models/cases/caseLawyer';
import { CaseOpponent } from '../models/cases/caseOpponent';
import { Claim } from '../models/cases/claim';
import { cities } from '../models/cities';
import { NgSelectProps } from '../models/ng-select-props';
import { User, UserRole } from '../models/users/user';
import { CharterCreateEditComponent } from 'src/app/shared/settings/charter-create-edit/charter-create-edit.component';
import { CircleCreateEditComponent } from 'src/app/shared/settings/circle-create-edit/circle-create-edit.component';
import { ClaimTypeCreateEditComponent } from 'src/app/shared/settings/claim-type-create-edit/claim-type-create-edit.component';
import { CourtCreateEditComponent } from 'src/app/shared/settings/court-create-edit/court-create-edit.component';
import { LawyerCreateEditComponent } from 'src/app/shared/settings/lawyer-create-edit/lawyer-create-edit.component';
import { OwnerCreateEditComponent } from 'src/app/shared/settings/owner-create-edit/owner-create-edit.component';
import { ProtectionClubCreateEditComponent } from 'src/app/shared/settings/protection-club-create-edit/protection-club-create-edit.component';
import { RepresentativeCreateEditComponent } from 'src/app/shared/settings/representative-create-edit/representative-create-edit.component';
import { SessionNoteCreateEditComponent } from 'src/app/shared/settings/session-note-create-edit/session-note-create-edit.component';
import { ShipsCreateEditComponent } from 'src/app/shared/settings/ships-create-edit/ships-create-edit.component';
import { CaseSubjectCreateEditComponent } from '../settings/case-subject-create-edit/case-subject-create-edit.component';
import { CasePostponeCreateEditComponent } from '../settings/case-postpone-create-edit/case-postpone-create-edit.component';

import { Charter } from 'src/app/shared/models/data/charter';
import { Owner } from 'src/app/shared/models/data/owner';
import { ProtectionClub } from 'src/app/shared/models/data/protectionClub';
import { Representative } from 'src/app/shared/models/data/representative';
import { Ship } from 'src/app/shared/models/data/ship';
import { Lawyer, LawyerLite } from 'src/app/shared/models/lawyers/lawyer';
import { Court } from '../models/courts/court';
import { Service } from '../models/services/service';
import { SearchParams } from '../models/searchParams';

@Component({
  selector: 'file-summary',
  templateUrl: './file-summary.component.html',
  styleUrls: ['./file-summary.component.scss']
})
export class SharedFileSummaryComponent implements OnInit, OnChanges {
  @Input() fileInfo: Case;
  @Input() editable: boolean;
  user: User;
  userRole = UserRole;
  cities = cities;
  editLawyer: CaseLawyer;
  editClaim: Claim;
  searchFileSeq = null;
  searchFileNum = null;
  filesSearchLoading = false;
  fileSearchError = false;
  caseWrite: Case = new Case();
  notCRMLawyers: CaseLawyer[] = [];
  CRMLawyers: CaseLawyer[] = [];

  relationshshipTypes: Service[] = [];
  selectedRelationship: number;
  selectedRelFileType: Service;
  selectedFileServices: Service[];

  statusEnum = StatusEnum;

  @ViewChild('caseLawyerModal') caseLawyerModal;
  @ViewChild('caseModal') caseModal;
  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;
  @ViewChild('claimModal') claimModal: CreateNewClaimComponent;
  @ViewChild('clientModal') clientModal: CreateEditFileClientComponent;
  @ViewChild('caseOpponentModal') caseOpponentModal: CreateEditCaseOpponentComponent;
  @ViewChild('lawyerHistoryModal') lawyerHistoryModal: CaseLawyerHistoryComponent;


  // add item to ng-select 
  @ViewChild('caseSubjectModal') caseSubjectModal: CaseSubjectCreateEditComponent;
  @ViewChild('lawyerModal') lawyerModal: LawyerCreateEditComponent;
  @ViewChild('shipModal') shipModal: ShipsCreateEditComponent;
  @ViewChild('ownerModal') ownerModal: OwnerCreateEditComponent;
  @ViewChild('charterModal') charterModal: CharterCreateEditComponent;
  @ViewChild('representativeModal') representativeModal: RepresentativeCreateEditComponent;
  @ViewChild('ownerClubModal') ownerClubModal: ProtectionClubCreateEditComponent;
  @ViewChild('charterClubModal') charterClubModal: ProtectionClubCreateEditComponent;
  @ViewChild('courtModal') courtModal: CourtCreateEditComponent;
  @ViewChild('circleModal') circleModal: CircleCreateEditComponent;
  @ViewChild('casePostponeModal') casePostponeModal: CasePostponeCreateEditComponent;
  @ViewChild('sessionNoteModal') sessionNoteModal: SessionNoteCreateEditComponent;
  @ViewChild('claimTypeModal') claimTypeModal: ClaimTypeCreateEditComponent;


  modalRef: NgbModalRef;

  public lawyerNgSelect = null;
  public positionNgSelect = null;
  public caseSubjectNgSelect = null;
  public shipNgSelect = null;
  public ownerNgSelect = null;
  public charterNgSelect = null;
  public representativeNgSelect = null;
  public clubNgSelect = null;
  public cityNgSelect = null;
  public fileTypeNgSelect = null;
  public fileServiceNgSelect = null;
  public casesNgSelect = null;


  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private filesApi: FilesApiService,
    private lawyerApi: LawyersApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private marineApi: MarineApiService,
    private printService: PrintService,
    private courtsApi: CourtsApiService,
    private servicesApi: ServicesApiService
  ) {
    this.loadRelationshipTypes();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fileInfo.currentValue.id !== changes.infoInfo?.previousValue?.id) {
      this.getNgSelectItems();
      this.lawyersFilter();

      this.selectedRelationship = this.fileInfo.relationship?.id;
      this.selectedRelFileType = this.fileInfo.relFileType;
      this.selectedFileServices = this.fileInfo.fileServices;

    }
  }

  ngOnInit(): void {
    this.user = this.authService.user;
  }

  getNgSelectItems() {
    this.lawyerNgSelect = new NgSelectProps(this.lawyerApi.getLawyersLite);
    this.positionNgSelect = new NgSelectProps(this.lawyerApi.getLawyerLevels);
    this.caseSubjectNgSelect = new NgSelectProps(this.filesApi.getCaseSubjects);
    this.shipNgSelect = new NgSelectProps(this.marineApi.getShips);
    this.ownerNgSelect = new NgSelectProps(this.marineApi.getOwners);
    this.charterNgSelect = new NgSelectProps(this.marineApi.getCharters);
    this.clubNgSelect = new NgSelectProps(this.marineApi.getClubs);
    this.representativeNgSelect = new NgSelectProps(this.marineApi.getRepresentatives);
    this.cityNgSelect = new NgSelectProps(this.courtsApi.getCities);
    this.fileTypeNgSelect = new NgSelectProps(this.servicesApi.getServicesByLayer, new SearchParams(), [2]);
    this.fileServiceNgSelect = new NgSelectProps(this.servicesApi.getServicesByLayer, new SearchParams(), [3]);
    this.casesNgSelect = new NgSelectProps(this.filesApi.getFilesTiny);


  }

  isEditable() {
    return this.user && (this.editable && (this.user.role === UserRole.ADMIN || this.user.role === UserRole.DATA_ENTRY))
      && this.fileInfo.status !== this.statusEnum.CLOSED
  }

  openCaseLawyerModal(l) {
    if (l) {
      this.editLawyer = Object.assign(new CaseLawyer(), l);
    } else {
      this.editLawyer = new CaseLawyer();
    }
    this.editLawyer.caseId = this.fileInfo.id;
    this.modalRef = this.modalService.open(this.caseLawyerModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }
  submitLawyer() {
    this.spinner.show();
    this.editLawyer.lawyerId = this.editLawyer.lawyer.id;
    if (!this.editLawyer.id) {
      this.filesApi.createCaseLawyer(this.editLawyer).subscribe(
        l => {
          this.fileInfo.lawyers.unshift(l);
          this.lawyersFilter();
          this.modalRef.close();
          this.spinner.hide();
          this.toastr.success('Lawyer Added', 'Success');
        }
      )
    } else {
      this.filesApi.updateCaseLawyer(this.editLawyer).subscribe(
        l => {
          this.fileInfo.lawyers = this.fileInfo.lawyers.map((val) => (val.id == l.id) ? l : val)
          this.lawyersFilter();
          this.spinner.hide();
          this.modalRef.close();
          this.toastr.success('Lawyer Updated', 'Success');
        }
      )
    }
  }
  deleteLawyer(l: CaseLawyer) {
    this.confirmModal.open(`Are you sure you want to delete '${l.getName}'`, () => {
      l.caseId = this.fileInfo.id;
      this.spinner.show();
      this.filesApi.deleteCaseLawyer(l).subscribe(
        r => {
          this.fileInfo.lawyers.splice(this.fileInfo.lawyers.findIndex((val, i, arr) => val.id === l.id), 1)
          this.lawyersFilter();
          this.spinner.hide();
          this.confirmModal.close();
          this.toastr.success('Lawyer Deleted', 'Success');
        }
      )
    });
  }

  openCaseModal() {
    this.caseWrite = Object.assign(new Case(), this.fileInfo);
    this.modalRef = this.modalService.open(this.caseModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }
  submitCase() {
    this.spinner.show();
    this.filesApi.updateCase(this.convertToCaseWrite(this.caseWrite)).subscribe(
      c => {
        this.fileInfo = this.caseWrite;
        this.modalRef.close();
        this.spinner.hide();
        this.toastr.success('File Updated', 'Success');
      }
    )
  }
  convertToCaseWrite(c: Case): CaseWrite {
    const caseBase: CaseBase = Object.assign(new CaseBase(), c);
    return Object.assign(new CaseWrite(), {
      ...caseBase,
      relatedCases: c.relatedCases.map(c => c.id),
      ships: c.ships ? c.ships.map((val) => val.id) : null,
      representativeId: c.representative ? c.representative.id : undefined,
      ownerClubId: c.ownerClub?.id,
      ownerId: c.owner?.id,
      charterClubId: c.charterClub?.id,
      charterId: c.charter?.id,
      nmLawyerId: c.nmLawyer?.id,
      cityId: c.city.id,
      services: [this.selectedRelationship, this.selectedRelFileType?.id, ...this.selectedFileServices.map(s => s.id)],

    });
  }

  // case lawyer logic
  updateRate(lawyer) {
    this.editLawyer.rate = lawyer ? lawyer.rate : null;
  }
  closeModal() {
    this.modalRef.close();
  }

  // CRM lawyers and not crm lawyers for UI
  lawyersFilter() {
    this.CRMLawyers = [];
    this.notCRMLawyers = [];
    this.fileInfo.lawyers.forEach((l) => {
      if (l.getPosition === 'CRM') {
        this.CRMLawyers.push(l);
      } else {
        this.notCRMLawyers.push(l);
      }
    })
  }

  openClaimModal(claim: Claim = new Claim()) {
    claim.caseId = this.fileInfo.id;
    this.claimModal.open(claim);
  }
  submitClaim(claim: Claim) {
    this.spinner.show();
    claim.claimTypeId = claim.claimType.id;
    if (!claim.id) {
      this.filesApi.createClaim(claim).subscribe(
        c => {
          this.fileInfo.claims.push(c);
          this.spinner.hide();
          this.toastr.success('Claim Added', 'Success');
        }
      )
    } else {
      this.filesApi.updateClaim(claim).subscribe(
        c => {
          this.fileInfo.claims.forEach((v, i, arr) => {
            if (v.id === c.id) {
              arr[i] = c;
            }
          })
          this.spinner.hide();
          this.toastr.success('Claim Updated', 'Success');
        }
      )
    }

  }
  deleteClaim(claim: Claim) {
    this.confirmModal.open(`Are you sure you want to delete '${claim.claimTypeStr}'`, () => {
      claim.caseId = this.fileInfo.id;
      this.spinner.show();
      this.filesApi.deleteClaim(claim).subscribe(
        c => {
          this.fileInfo.claims.splice(this.fileInfo.claims.findIndex((val) => val.id === claim.id), 1);
          this.spinner.hide();
          this.confirmModal.close();
          this.toastr.success('Claim Deleted', 'Success');
        }
      )
    });
  }

  openClientModal(client: CaseClient = new CaseClient()) {
    client.caseId = this.fileInfo.id;
    this.clientModal.open(client);
  }

  submitClient(client: CaseClient) {
    this.spinner.show();
    if (!client.id) {
      this.filesApi.createCaseClient(client).subscribe(
        c => {
          this.fileInfo.clients.unshift(c);
          this.spinner.hide();
          this.toastr.success('Case Client Added', 'Success');
        }
      )
    } else {
      this.filesApi.updateCaseClient(client).subscribe(
        c => {
          this.fileInfo.clients.forEach((v, i, arr) => {
            if (v.id === c.id) {
              arr[i] = c;
            }
          })
          this.spinner.hide();
          this.toastr.success('Case Client Updated', 'Success');
        }
      )
    }

  }
  deleteClient(client: CaseClient) {
    this.confirmModal.open(`Are you sure you want to delete '${client.client.fullName}'`, () => {
      client.caseId = this.fileInfo.id;
      this.spinner.show();
      this.filesApi.deleteCaseClient(client).subscribe(
        c => {
          this.fileInfo.clients.splice(this.fileInfo.clients.findIndex((val) => val.id === client.id), 1)
          this.spinner.hide();
          this.confirmModal.close();
          this.toastr.success('Case Client Deleted', 'Success');
        }
      )
    });
  }

  openOpponentModal(opponent: CaseOpponent = new CaseOpponent()) {
    opponent.caseId = this.fileInfo.id;
    this.caseOpponentModal.open(opponent);
  }

  submitOpponent(opponent: CaseOpponent) {
    this.spinner.show();
    if (!opponent.id) {
      this.filesApi.createCaseOpponents(opponent).subscribe(
        c => {
          this.fileInfo.opponents.unshift(c);
          this.spinner.hide();
          this.toastr.success('Case CaseOpponent Added', 'Success');
        }
      )
    } else {
      this.filesApi.updateCaseOpponents(opponent).subscribe(
        c => {
          this.fileInfo.opponents.forEach((v, i, arr) => {
            if (v.id === c.id) {
              arr[i] = c;
            }
          })
          this.spinner.hide();
          this.toastr.success('Case Opponent Updated', 'Success');
        }
      )
    }

  }
  deleteOpponent(opponent: CaseOpponent) {
    this.confirmModal.open(`Are you sure you want to delete '${opponent.opponent.fullName}'`, () => {
      opponent.caseId = this.fileInfo.id;
      this.spinner.show();
      this.filesApi.deleteCaseOpponents(opponent).subscribe(
        c => {
          this.fileInfo.opponents.splice(this.fileInfo.opponents.findIndex((val) => val.id === opponent.id), 1)
          this.spinner.hide();
          this.confirmModal.close();
          this.toastr.success('Case Opponent Deleted', 'Success');
        }
      )
    });
  }

  onPrint() {
    this.printService.data = { fileInfo: this.fileInfo, notCRMLawyers: this.notCRMLawyers, CRMLawyers: this.CRMLawyers };
    this.printService.printDocument('file-summary');
  }

  openLawyerHistoryModal() {
    this.spinner.show();
    this.filesApi.caseLawyerHistory(this.fileInfo.id).subscribe(
      r => {
        this.lawyerHistoryModal.open(r);
        this.spinner.hide();
      }
    )
  }


  submitContact(file: Case) {
    this.fileInfo = Object.assign(new Case(), file);
  }


  // Ng Select

  addLawyerFn = (name) => this.addItemFn(new Lawyer(), name, this.lawyerModal, 'name', 'nameAr');

  addShipFn = (ship) => this.addItemFn(new Ship(), ship, this.shipModal, 'name');

  addOwnerFn = (owner) => this.addItemFn(new Owner(), owner, this.ownerModal, 'name');

  addOwnerClubFn = (club) => this.addItemFn(new ProtectionClub(), club, this.ownerClubModal, 'name');

  addCharterClubFn = (club) => this.addItemFn(new ProtectionClub(), club, this.charterClubModal, 'name');

  addCharterFn = (charter) => this.addItemFn(new Charter(), charter, this.charterModal, 'name');

  addRepresentativeFn = (rep) => this.addItemFn(new Representative(), rep, this.courtModal, 'name');

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

  lawyerSubmit(lawyer: Lawyer) {
    this.caseWrite.nmLawyer = Object.assign(new LawyerLite(), lawyer);
    this.lawyerModal.close();
    this.toastr.success('Lawyer added', 'Success!');
  }

  shipSubmit = (ship: Ship) => {
    this.caseWrite.ships.push(ship);
    this.caseWrite.ships = [...this.caseWrite.ships];
    this.shipModal.close();
    this.toastr.success('Ship added', 'Success!');
  }
  ownerSubmit(owner: Owner) {
    this.caseWrite.owner = owner;
    this.ownerModal.close();
    this.toastr.success('Owner added', 'Success!');
  }
  charterSubmit(charter: Charter) {
    this.caseWrite.charter = charter;
    this.charterModal.close();
    this.toastr.success('Charter added', 'Success!');
  }
  representativeSubmit(representative: Representative) {
    this.caseWrite.representative = representative;
    this.representativeModal.close();
    this.toastr.success('Representaive added', 'Success!');
  }
  ownerClubSubmit(club: ProtectionClub) {
    this.caseWrite.ownerClub = club;
    this.ownerClubModal.close();
    this.toastr.success('Club added', 'Success!');
  }
  charterClubSubmit(club: ProtectionClub) {
    this.caseWrite.charterClub = club;
    this.charterClubModal.close();
    this.toastr.success('Club added', 'Success!');
  }
  courtSubmit(court: Court) {
    this.caseWrite.session.court = court;
    this.caseSubjectModal.close();
    this.toastr.success('Case Subject added', 'Success!');
  }


  loadRelationshipTypes() {
    this.spinner.show();
    this.servicesApi.getServicesByLayer(new SearchParams(), 1).subscribe(r => {
      this.spinner.hide();
      this.relationshshipTypes = r.results;
    })
  }

  searchFn() {
    return true;
  }


}
